export const downloadXLSX = async ({ rootGetters }, {
    payload
}) => {
    const organizationId = rootGetters['app/getSelectedOrganization'].id

    const jsonPayload = encodeURIComponent(JSON.stringify(payload))

    window.open('/downloads/xlsx-swaps?_=' + `${jsonPayload}&organizationId=${organizationId}`)
}